import React from 'react'
import ChildrenType from '@shapr/react-shared/types/Children'
import { useSetState, } from 'react-use'

import GlobalContext from '~/contexts/GlobalContext'
import localStorageConfig from '~/config/localStorageConfig'

const GlobalProvider = props => {
  const { children, } = props

  const [globalContextValue, setGlobalContext,] = useSetState({
    authToken: localStorage.getItem(localStorageConfig.authToken) || undefined,
  })

  return (
    <GlobalContext.Provider value={{ ...globalContextValue, setGlobalContext, }}>
      {children}
    </GlobalContext.Provider>
  )
}

GlobalProvider.propTypes = {
  children: ChildrenType.isRequired,
}

export default React.memo(GlobalProvider)
